import React, { useEffect, useState } from 'react'
import { Card, Button, Alert, Form } from 'react-bootstrap'
import { FaRegCopy } from 'react-icons/fa'

interface Props {
    username?: string
    scriptNumber: number
    canCopy: boolean
}

const ScriptCard: React.FC<Props> = ({
    username,
    scriptNumber,
    canCopy,
}) => {
    const [copied, setCopied] = useState(false)

    const scriptPath = scriptNumber === 1 ? 'script.js' : `script-${scriptNumber}.js`
    const script = `<script src="https://cdn.nordpar.com/api/${username}/${scriptPath}"></script>`

    const handleCopy = () => {
        if (!canCopy) return
        navigator.clipboard.writeText(script)
        setCopied(true)
        setTimeout(() => setCopied(false), 2000)
    }

    return (
        <Card className="shadow-sm border-0 mb-4">
            <Card.Header className="bg-white border-0 pt-4 px-4 pb-0">
                <h5 className="mb-0">Script</h5>
            </Card.Header>

            <Card.Body className="px-4 pt-3 pb-4">
                <div style={{ maxWidth: '960px' }}>
                    <div className="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center gap-3 mb-3">
                        <Form.Control
                            type="text"
                            readOnly
                            value={script}
                            className="bg-light monospace"
                        />

                        <Button variant="outline-secondary" onClick={handleCopy} disabled={!canCopy} className="flex-shrink-0 px-3 align-self-lg-stretch">
                            <FaRegCopy className="me-2" />
                            Copy script
                        </Button>
                    </div>
                </div>

                <div className="text-muted small mb-0">
                    Copy the script above and insert it before <code>&lt;/body&gt;</code> on your website.
                </div>

                {!canCopy && (
                    <div className="text-muted small mt-3">
                        Save the new script before copying it.
                    </div>
                )}

                {copied && (
                    <Alert variant="success" className="mt-3 mb-0">
                        Script copied to clipboard.
                    </Alert>
                )}
            </Card.Body>
        </Card>
    )
}

export default ScriptCard
